import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { MessengerService } from '../../services/messenger/messenger.service';
import { logoutOnboarding } from '../actions/onboarding-auth.actions';
import { logoutOAuth } from '../actions/session-auth.actions';

@Injectable()
export class MessengerSessionEffects {
  constructor(
    private messengerService: MessengerService,
    private actions$: Actions,
  ) {}

  onAppLogout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(logoutOAuth, logoutOnboarding),
        tap(() => this.messengerService.logout()),
      ),
    { dispatch: false },
  );
}
